export { default } from 'ember-composability-tools/components/node';
